import { render } from "./ProductCatalog.vue?vue&type=template&id=e287b73a&scoped=true"
import script from "./ProductCatalog.vue?vue&type=script&lang=js"
export * from "./ProductCatalog.vue?vue&type=script&lang=js"

import "./ProductCatalog.vue?vue&type=style&index=0&id=e287b73a&lang=less&scoped=true"
import "./ProductCatalog.vue?vue&type=style&index=1&id=e287b73a&lang=less"
import "./ProductCatalog.vue?vue&type=style&index=2&id=e287b73a&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e287b73a"]])

export default __exports__